<template>
  <template v-if="sections.length">
    <section
      class="card section padding__lr--24 padding__tb--18"
      v-for="section in sections"
      :key="section.id"
    >
      <procedure-blocks :blocks="section.blocks.getAvailableBlocks({ ...procedure_execution, client })" />
    </section>
  </template>
</template>

<script setup>
import { inject } from 'vue'
import { useClientStore } from '@/stores/ClientStore'
import { useProcedureSections } from '@/composables/modules/procedures'

import ProcedureBlocks from '&/modules/procedures/layouts/ProcedureBlocks'

const procedure = inject('procedure')
const procedure_execution = inject('procedure_execution')

const { getClient } = useClientStore()
const { sections } = useProcedureSections({ procedure, procedure_execution })

const { client } = getClient()
</script>

<style lang="scss" scoped>
.section {
  &:not(:last-child) {
    margin-bottom: 24px;
  }
}
</style>